// extracted by mini-css-extract-plugin
module.exports = {"header":"WidgetTitle_header__202fA","title":"WidgetTitle_title__1Mz02","addon":"WidgetTitle_addon__1wP51"};